import { callOnValueChangeFactory } from "./util/general";
import { onModifiedChange } from "./onModifiedChange";

const handleOnBeforeUnload = (e) => {
  e.preventDefault();
  const message =
    "If you leave the page now your changes will not be saved. Leave page?";
  e.returnValue = message;
  return message;
};

const askIfIsModified = callOnValueChangeFactory((isModified) => {
  // Onbeforeunload is a tricky event. Handling it here in accordance to MDN best practices
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
  if (isModified) {
    window.addEventListener("beforeunload", handleOnBeforeUnload, {
      capture: true,
    });
  } else {
    window.removeEventListener("beforeunload", handleOnBeforeUnload, {
      capture: true,
    });
  }
}, false);

export const enableLeavePageConfirmation = (store) =>
  onModifiedChange(store, askIfIsModified);
